import api from 'api';

const rejectQuote = async ({ ticketId, quoteId, feedBackDTO }) => {
  return api.post(
    `price-negotiation/tickets/${ticketId}/quotes/${quoteId}/rejections/`,
    { feedback: { ...feedBackDTO, stars: 0 } }
  );
};

export default rejectQuote;
